<template>
  <div class="page">
    <problem-list ref="problem-List" />
  </div>
</template>

<script>
import ProblemList from "./components/problemList.vue";
export default {
  components: { ProblemList },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped></style>
